import { useEffect, useState } from 'react'
import { CreditCard, CircleDollarSign } from 'lucide-react'
import Item from './Item'
import { Button } from 'components/Button'
import { connect } from 'react-redux';
import { StripeActions } from 'store/actions';
import toast from 'react-hot-toast'
import { PortalSpinner } from 'components/PortalSpinner'

let enhancer = connect(null, { ...StripeActions });

const PaymentMethods = ({
  treatmentPlanId,
  setPaymentState,
  setSelectedMethod,
  getFinancialArrangments,
  updateFinancialArrangments
}) => {
  const [selectedOption, setSelectedOption] = useState('pay_in_full')
  const [financialArrangments, setFinancialArrangments] = useState(null)
  const [loading, setLoading] = useState(false);

  let { payment_options } = financialArrangments?.attributes || {}

  useEffect(() => {
    loadFinancialArrangments()
  }, [treatmentPlanId]);

  const loadFinancialArrangments = async () => {
    try {
      const { data } = await getFinancialArrangments({ resource_type: 'TreatmentPlan', resource_id: treatmentPlanId });

      setFinancialArrangments(data);
    } catch (error) {
      setFinancialArrangments({ attributes: { payment_options: null } });
      toast.error(error.errors || 'Failed to load payment methods');
    }
  };

  const continueToPayment = async () => {
    setLoading(true)
    try {
      await updateFinancialArrangments(
        { financial_arrangement: { payment_schedule_type: selectedOption } },
        { resource_type: 'TreatmentPlan', resource_id: treatmentPlanId }
      );

      setSelectedMethod(payment_options[selectedOption])
      setPaymentState('make_payment');
    } catch (error) {
      toast.error(error.errors || 'Failed to continue to payment');
    }
    setLoading(false)
  }

  if (!financialArrangments) return <PortalSpinner />;
  if (!payment_options) return <div className="py-6 text-center text-sm text-secondary-400">No payment method found.</div>;

  return (
    <div className="w-full space-y-6 py-4">
      <div className="text-center space-y-2">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-blue-50 text-blue-600 mb-1">
          <CreditCard size={20} />
        </div>
        <h2 className="text-lg font-bold text-secondary-900">Choose Payment Method</h2>
        <p className="text-xs text-secondary-500 max-w-md mx-auto">Select how you would like to take care of your treatment balance.</p>
      </div>

      <div className="w-full lg:max-w-[60%] mx-auto mt-6">
        <div className="flex flex-col gap-3 justify-between">
          {Object.entries(payment_options).map(([key, item]) => (
            <Item
              key={key}
              item={item}
              isSelected={selectedOption === key}
              onSelect={() => setSelectedOption(key)}
            />
          ))}
        </div>

        <div className="flex justify-center mt-6">
          <Button
            title="Continue to Payment"
            variant="tertiary"
            icon={<CircleDollarSign size={16} />}
            onClick={continueToPayment}
            loading={loading}
          />
        </div>
      </div>
    </div>
  )
}

export default enhancer(PaymentMethods);
